import { Domain } from '@3nickels/data-modules';
import { Link, Typography, TypographyProps } from '@mui/material';
import i18next, { t } from 'i18next';
import { Trans } from 'react-i18next';
import { formatDecimalDollars } from '../../helpers/utilityFunctions';
import { getInterval } from '../../pages/settings/manage-subscription/functions';
import useDocs from '../terms-and-conditions/useDocs';

interface InternalFreeTrialFootnoteProps extends Omit<TypographyProps, 'children'> {
  pricebookBundle: Domain.PricebookBundle;
  showAsterisk?: boolean;
}

const InternalFreeTrialFootnote: React.FC<InternalFreeTrialFootnoteProps> = ({
  pricebookBundle,
  showAsterisk = true,
  ...typographyProps
}) => {
  const { language } = i18next;
  const { terms } = useDocs();

  return (
    <Typography {...typographyProps}>
      {showAsterisk && '* '}
      {t('SubscriptionNotRequiredDuringFreeTrial', {
        price: formatDecimalDollars(pricebookBundle.pricebook.metadata.advicePrice, language),
        interval: t(getInterval(pricebookBundle.prices[0].intervalType)),
      })}{' '}
      <Trans
        i18nKey='PleaseSeeTOSandCancellationPolicy'
        components={{
          TermsOfService: <Link href={terms} target='_blank' />,
          CancellationPolicy: <Link href='/cancellation-policy' target='_blank' />,
        }}
      />
    </Typography>
  );
};

export default InternalFreeTrialFootnote;
